var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserchatbot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #21519e;\n        fill-rule: evenodd;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #b3b3b3;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 10,
    width: 50,
    height: 50,
    rx: 8,
    ry: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_5.-Icon_c.-Outlined_c.6-User_avatar-User",
    "data-name": "5.-Icon/c.-Outlined/c.6-User/avatar-User"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "cls-1",
    d: "M29.98,23.05c-2.28,0-4.49-.68-6.4-1.94-1.9-1.27-3.37-3.07-4.26-5.17-.86-2.11-1.09-4.42-.63-6.66.43-2.24,1.53-4.29,3.14-5.9,1.61-1.61,3.66-2.71,5.91-3.16,2.25-.45,4.55-.22,6.66.65,2.1.87,3.92,2.35,5.19,4.25,1.27,1.89,1.93,4.12,1.93,6.4,0,3.06-1.21,5.99-3.37,8.15-2.16,2.16-5.1,3.38-8.15,3.38ZM49,46.1H11v-10.85c0-2.16.87-4.23,2.39-5.75,1.52-1.53,3.58-2.38,5.75-2.38h21.71c2.17,0,4.23.86,5.75,2.38,1.52,1.53,2.39,3.6,2.39,5.75v10.85Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserchatbot);
export default __webpack_public_path__ + "static/media/userchatbot.331d68423954fad4ad4cdc5dcb759f04.svg";
export { ForwardRef as ReactComponent };